import React, { useEffect } from 'react';
import { Box, Typography, Link } from '@mui/material';
import ScienceIcon from '@mui/icons-material/Science';
import { isTestEnvironment } from '../utils/apiConfig';

// Waarschuwt op test.fullframe.nl dat dit NIET de productie-omgeving is.
// Aanleiding: test draait sinds de splitsing op een eigen database (ff-interne-pg-test)
// met een eigen PG-database. Projecten/taken/draaidagen komen via de sync uit het
// GEDEELDE Airtable en zijn dus echt (de-geanonimiseerd op verzoek, 20 aug). Zonder banner
// is dat niet te zien. Niet dismissible: juist de mensen die test per ongeluk als
// productie gebruiken zouden 'm anders wegklikken en het verschil alsnog missen.
//
// Maar "wijzigingen komen NIET in productie" was te absoluut, en daarmee gevaarlijk.
// Dat geldt alleen voor onze eigen database. De Airtable-base staat hardgecodeerd in
// backend/utils/airtableConfig.js:14 — test en productie schrijven naar dezelfde base.
// Wie op dit scherm een taak verzet of een draaidag aanpast, doet dat dus in de echte
// planning van collega's. Een banner die het tegendeel belooft is erger dan geen banner.
//
// Reserveringen staan hier bewust NIET meer bij: die leven sinds de ontkoppeling
// volledig in Postgres (materialen.js — "PostgreSQL is de enige bron voor
// reserveringen") en test heeft een eigen database. Een reservering op test is dus
// wél gewoon oefenen.
const TestEnvironmentBanner = () => {
  // Ook de browser-tab moet schreeuwen dat dit test is — met tien tabs open is
  // de banner niet zichtbaar maar de tabtitel wel (verzoek 20 aug).
  useEffect(() => {
    if (isTestEnvironment) document.title = '🧪 TEST | Full Frame';
  }, []);

  if (!isTestEnvironment) return null;

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: 'sticky',
        top: 0,
        // Onder MUI-modals (1300): drawers/dialogs (o.a. het Offerteregels-
        // paneel) horen óver de banner te vallen, niet erachter weg te vallen.
        zIndex: 1250,
        bgcolor: '#fee2e2',
        color: '#991b1b',
        borderBottom: '2px solid #dc2626',
        px: 2,
        py: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        flexWrap: 'wrap',
        textAlign: 'center',
      }}
    >
      <ScienceIcon sx={{ fontSize: 18 }} />
      <Typography component="span" sx={{ fontWeight: 900, fontSize: '1.15rem', letterSpacing: '0.12em', color: 'inherit', lineHeight: 1 }}>
        TEST
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 700, color: 'inherit' }}>
        — eigen database, maar Airtable is gedeeld met productie:
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 700, color: 'inherit' }}>
        projecten, taken, draaidagen en callsheets zijn écht — wat je daar wijzigt, wijzig je echt.
      </Typography>
      <Link
        href="https://intern.fullframe.nl"
        sx={{ fontWeight: 700, color: 'inherit', textDecorationColor: 'currentColor' }}
      >
        Naar intern.fullframe.nl →
      </Link>
    </Box>
  );
};

export default TestEnvironmentBanner;
